import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(true);

  loading$ = this.loadingSubject.asObservable();

  private loadingTimeout: ReturnType<typeof setTimeout> = setTimeout(
    () => {},
    0
  );
  private readonly minDisplayTime = 0; // Minimum time to display the spinner in ms
  private readonly delayTime = 0;

  setLoading(isLoading: boolean): void {
    if (isLoading) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(() => {
        this.loadingSubject.next(true);
      }, this.delayTime);
    } else {
      clearTimeout(this.loadingTimeout);
      setTimeout(() => {
        this.loadingSubject.next(false);
      }, this.minDisplayTime);
    }
  }
}
